import CourseForm from "../../components/CourseForm/CourseForm";
const EditCourse = () => {
    return (
        <div style={{ marginTop: '3%' }}>
            <CourseForm type="Edit" />
        </div>
    )
}
export default EditCourse;